import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { routes } from "consts";
import React from "react";

import { useNavigate, useParams } from "react-router-dom";
import { UserForm, UserFormValues } from "./UserForm/UserForm";
import { useStudent } from "api/hooks/useStudent";
import { PaziaLoader } from "components/atoms";
import { studentsApi } from "api/studentsApi";
import { useToaster } from "utils";

export const EditStudentPage = () => {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { loading, data } = useStudent(Number(studentId));

  if (loading) return <PaziaLoader position="center" />;
  if (!data) return null;

  const breadcrumbs = [
    { title: "Użytkownicy", path: routes.STUDENTS },
    { path: routes.STUDENT(studentId), title: data.firstName + " " + data.surname },
    { title: "Edytuj" },
  ];

  const onSubmit = async (data: UserFormValues) => {
    try {
      await studentsApi.update(Number(studentId), data);
      navigate(routes.STUDENTS);
      showSuccess("Użytkownik został zaktualizowany.");
    } catch (e) {
      showError("Nie udało się zaktualizować użytkownika.");
      console.error(e);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj użytkownika" />
      <UserForm onSubmit={onSubmit} student={data} disableEmail />
    </PageMain>
  );
};

// !TODO monity o platnosciach
